import React, { useMemo } from "react";
import { css } from "glamor";
import { spacing } from "../library/theme";
import { Widget } from "@typeform/embed-react";
import { makeIsMobile } from "../../utils/useScreenWidth";

const typeformWrapper = css({
  paddingTop: spacing.m,
});

export default function LessonTypeformSurvey({ typeformId, hidden }) {
  const isMobile = makeIsMobile();

  if (!typeformId) return null;

  const widgetKey = useMemo(() => {
    if (!hidden) return typeformId;

    return `${typeformId}-${JSON.stringify(hidden)}`;
  }, [typeformId, hidden]);

  const widgetStyle = {
    width: "100%",
    height: isMobile ? "calc(100vh - 200px)" : "calc(100vh - 280px)",
    minHeight: isMobile ? "400px" : "500px",
    overflow: "hidden",
  };

  return (
    <div className={typeformWrapper}>
      <Widget
        key={widgetKey}
        id={typeformId}
        style={widgetStyle}
        hidden={hidden || {}}
        autoResize
      />
    </div>
  );
}
